import authInterceptor from '@/services/interceptors/auth.interceptor'; // eslint-disable-line
import errorInterceptor from '@/services/interceptors/error.interceptor'; // eslint-disable-line
import unboxingInterceptor from '@/services/interceptors/unboxing.interceptor';

import REST from './rest';

const API_URL = 'https://www.epfootwear.com';
// const API_URL = 'http://localhost:8080';

class APIService extends REST {
  constructor() {
    super(`${API_URL}/api`);
    this.useInterceptor(
      authInterceptor,
      unboxingInterceptor,
      errorInterceptor,
    );
    console.log('Base Url:', this.endPointURL);
  }

  create(url = this.API_URL, config) {
    return new REST(url, config);
  }
}

export default new APIService();
